/**This class is automatically generated by LayaAirIDE, please do not make any modifications. */


/**
 * Scene.ls
 */
export class LoadingRTBase extends Laya.Scene {
    public progress!: Laya.ProgressBar;
}

